import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "BusinessService",
  controller: "BusinessPayOrder",
};

const methods = [
  "AddItem",
  "UpdateItem",
  "DelItem",
  "GetItemById",
  "FindByConditions",
  "FindAll",
  "GetPageContentByConditions",
  "GetDataPageContentByConditions",
  "CreateOrder",
  "QueryOrder",
  "AuthorWxUrl",
  "AuthorAliPayUrl",
  "GetOpenId",
  "WxCallBack"
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
      Fun.prototype[path] = function(data) {
        return this.post(path, data);
      };
  });
};

const BusinessPayOrderApi = ZJApi.defineNewApi("BusinessPayOrderApi", factory);

export default BusinessPayOrderApi;
